// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"TablePreview_previewContainer__3nbji"};